import { render, staticRenderFns } from "./UserInfos.vue?vue&type=template&id=5b6a6d6e&"
import script from "./UserInfos.vue?vue&type=script&lang=js&"
export * from "./UserInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports